import React from "react";
import { FaBullseye, FaEye, FaUsers } from "react-icons/fa";

const AboutSection = () => {
  return (
    <section className="home-section" id="about">
      <div className="home-container">
        <div className="mb-8">
          <span className="section-kicker">About Us</span>
          <h2 className="home-title mt-4 text-2xl font-bold sm:text-4xl">Who we are, what we believe, and where we are going.</h2>
        </div>

        <div className="grid home-stagger-grid gap-4 lg:grid-cols-3">
          <article className="home-card p-6 lg:col-span-1">
            <div className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-full" style={{ background: "var(--surface-soft)" }}>
              <FaUsers />
            </div>
            <h3 className="text-lg font-semibold">About GUBCPC</h3>
            <p className="mt-3 text-sm leading-7 home-muted">
              GUB Competitive Programming Community helps students become strong problem solvers through regular training, contests, and mentorship. We welcome learners from all levels.
            </p>
          </article>

          <article className="home-card p-6">
            <div className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-full" style={{ background: "var(--surface-soft)" }}>
              <FaBullseye />
            </div>
            <h3 className="text-lg font-semibold">Mission</h3>
            <p className="mt-3 text-sm leading-7 home-muted">
              Build a disciplined competitive programming culture at GUB by making high-quality practice, guidance, and contests accessible to every motivated student.
            </p>
          </article>

          <article className="home-card p-6">
            <div className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-full" style={{ background: "var(--surface-soft)" }}>
              <FaEye />
            </div>
            <h3 className="text-lg font-semibold">Vision</h3>
            <p className="mt-3 text-sm leading-7 home-muted">
              Become one of the strongest university programming communities in Bangladesh, consistently producing confident coders and top national contest performers.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
